/*!

=========================================================
* Paper Dashboard React - v1.3.2
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

* Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import { useEffect, useState } from "react";
import axios from "axios";
import { Button } from 'reactstrap';
import { ref as storageRef, uploadBytes } from 'firebase/storage'; // Importuj ref i uploadBytes z firebase/storage
import { onAuthStateChanged} from 'firebase/auth';
import { doc, getDoc, setDoc } from "firebase/firestore";
import { auth, storage, db } from "../firebase"
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";

function Backup() {
  const navigate = useNavigate();
  const [conditionStatus, setConditionStatus] = useState();
  const [change, setChange] = useState(true);

  const openToast = (message) => {
    const Toastify__toast = document.querySelector(".Toastify__toast ");
    if (Toastify__toast === null) {
      toast.success(message, {
        position: "top-center",
      });
    }
  };

  useEffect(() => {
    const getConditionStatus = async () => {
      const docRef = doc(db, 'conditionStatus', 'iksUib31RmcDRaj8L702');
      const response = await getDoc(docRef);
  
      if(response.exists()){
        const conditionStatus = response.data().conditionStatus;
        setConditionStatus(conditionStatus);
      }
    }

    getConditionStatus();
  }, [change])

  const changeConditionStatus = async() => {
    const docRef = doc(db, 'conditionStatus', 'iksUib31RmcDRaj8L702');

    await setDoc(docRef, {
      conditionStatus: !conditionStatus
    }).then(() => { setChange(!change); openToast('The condition status has been successfully changed.') })
  }

  const handleBackup = async () => {
    try {
      const response = await axios.post('http://localhost:8080/createBackup');
      
      if (response.data) {
        const blob = new Blob([JSON.stringify(response.data)], { type: 'application/json' });
        const backupRef = storageRef(storage, 'backup.json'); // Użyj storageRef do uzyskania referencji
  
        // Użyj uploadBytes do przesłania pliku
        await uploadBytes(backupRef, blob).then(() => openToast('The backup has been successfully completed.'));
      }
    } catch (error) {
      console.error('Error creating backup:', error); // Obsługa błędów
    }
  };

 
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) { // Sprawdzenie, czy użytkownik jest zalogowany
        if (user.displayName === 'porter') {
          navigate('/super-admin/parking-map');
        } else if (user.displayName === 'manager') {
          navigate('/super-admin/pre-alerts-managment');
        }
      } else {
        navigate('/sign-in'); // Opcjonalnie: Przekierowanie do logowania, jeśli użytkownik nie jest zalogowany
      }
    });

    // Zwrócenie funkcji unsubscribing do czyszczenia
    return () => unsubscribe();
  }, [navigate]); // Dodanie navigate do zależności

  useEffect(() => {
    console.log(storage)
  }, [storage])

  return (
    <>
      <link
        href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css"
        rel="stylesheet"
        integrity="sha384-T3c6CoIi6uLrA9TneNEoa7RxnatzjcDSCmG1MXxSR1GAsXEV/Dwwykc2MPK8M2HN"
        crossOrigin="anonymous"
      />
      <ToastContainer style={{ width: "800px" }} autoClose={2000} />
      <div className="content" style={{ display: 'flex', flexDirection: 'column' }}>
        <h4>Create a backup of the database containing pre-alerts.</h4>
        <Button onClick={handleBackup} className="btn btn-warning" style={{ width: '100px' }}>Backup</Button>
        <a href='https://console.firebase.google.com/u/2/project/slam-project-136f8/storage/slam-project-136f8.appspot.com/files'>Last backup</a>
        <h4 style={{ marginTop: '40px' }}>Change the status of a condition in the pre-alert form.</h4>
        <Button onClick={changeConditionStatus} className="btn btn-warning" style={{ width: '200px' }}>{conditionStatus ? 'Disabled Condition' : 'Enabled Condition'}</Button>
      </div>
    </>
  );
}

export default Backup;
